import { useLocation, useNavigate } from 'react-router-dom';
import { getAlternateLocalePath, isEnglishPath } from '../data/i18nRoutes';
import { setLangPreference } from '../utils/langPreference';

const LanguageSwitcher = ({ className = '' }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const en = isEnglishPath(pathname);

  const switchTo = (targetLang) => {
    if (targetLang === 'en' && en) return;
    if (targetLang === 'fr' && !en) return;
    const nextPath = getAlternateLocalePath(pathname);
    setLangPreference(targetLang);
    navigate(nextPath);
  };

  return (
    <div className={`flex items-center gap-1 text-xs sm:text-sm font-semibold ${className}`}>
      <button
        type="button"
        onClick={() => switchTo('fr')}
        className={`px-2 py-1 sm:px-2.5 sm:py-1.5 rounded touch-manipulation ${!en ? 'bg-blue-600 text-white' : 'text-slate-600 dark:text-slate-400 hover:text-blue-600'}`}
        aria-pressed={!en}
        aria-label="Français"
      >
        FR
      </button>
      <span className="text-slate-300" aria-hidden="true">|</span>
      <button
        type="button"
        onClick={() => switchTo('en')}
        className={`px-2 py-1 sm:px-2.5 sm:py-1.5 rounded touch-manipulation ${en ? 'bg-blue-600 text-white' : 'text-slate-600 dark:text-slate-400 hover:text-blue-600'}`}
        aria-pressed={en}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
